import React from 'react'
import { useTranslation } from 'react-i18next'
import { UsersRound } from 'lucide-react'
import './CanvasShareButton.scss'
import { WithTooltip } from '@/src/renderer/components/ui/tooltip'

export interface CanvasShareButtonProps {
  className?: string
}

/**
 * „Freigeben" — linker Teil der Aktionsgruppe oben rechts im geöffneten
 * Projekt-Canvas (Figma `Secondary Button` 4956:104727).
 *
 * NOCH OHNE FUNKTION: Das Teilen von Projekten gibt es weder im Renderer noch
 * in Supabase. Der Knopf steht bewusst schon da — klickbar, ohne Wirkung —
 * wie `applyTasks` in der `CanvasToolbar` daneben. Wer die Freigabe baut,
 * hängt hier den Handler ein; sonst nichts.
 */
export const CanvasShareButton: React.FC<CanvasShareButtonProps> = ({ className }) => {
  const { t } = useTranslation()

  return (
    <WithTooltip content={t('projectCanvas.toolbar.share')}>
      <button
        type="button"
        className={`canvas-share-button${className ? ` ${className}` : ''}`}
      >
        <UsersRound size={16} strokeWidth={2} />
        <span className="canvas-share-button__label">{t('projectCanvas.toolbar.share')}</span>
      </button>
    </WithTooltip>
  )
}
